import HtmlElementHelper from '../../Shared/Helpers/htmlElementHelper';
import NumberHelper from './../../Shared/Helpers/numberHelper';

jQuery(document).ready(function () {
    if (HtmlElementHelper.g_elementExists('outletId')) {
        var o = document.getElementById('outletId');
        window.fonmoney_amount.pageLoad(o);
        o.onchange = function(event) {
            window.fonmoney_amount.outletIdChanged(event);
        };
    }
});

window.fonmoney_amount = {
    _exchangeRate: null, _senderCurrency: null, _receiverCurrency: null, _providerFee: null,
    providerFee: null, maxReceivingAmount: null,
    init: function(exchangeRate, senderCurrency, receiverCurrency, providerFee) {
        this._exchangeRate = NumberHelper.toNumber(exchangeRate, 4);
        this._senderCurrency = senderCurrency;
        this._receiverCurrency = receiverCurrency;
        if(providerFee !== "")
            this._providerFee = NumberHelper.toNumber(providerFee);
    },

    resetSummary: function() {
        this.updateSummary();
    },

    updateSummary: function() {
        this._senderCurrency = document.querySelector('#senderCurrency').value;
        this._receiverCurrency = document.querySelector('#receiverCurrency').value;
        const providerFee = document.querySelector('#provider-fee');
        if(providerFee !== null) {
            // Extraer solo el número antes del espacio/currency y convertirlo correctamente
            let amountSending = document.querySelector("#amount-sending").textContent;
            let sending = 0;
            if (amountSending) {
                let match = amountSending.match(/([\d.,]+)/);
                if (match) {
                    // Reemplazar coma por nada y punto por decimal si es necesario
                    let clean = match[1].replace(/,/g, '');
                    sending = parseFloat(clean);
                }
            }

            let amountFee = document.querySelector("#amount-fee").textContent;
            let fee = 0;
            if (amountFee) {
                let match = amountFee.match(/([\d.,]+)/);
                if (match) {
                    let clean = match[1].replace(/,/g, '');
                    fee = parseFloat(clean);
                }
            }
            let providerFeePer = 0;
            if(this._providerFee !== null) {
                providerFeePer = (sending * this._providerFee) / 100;
            }
            const pFeeStr = NumberHelper.formatAmount((this.providerFee != null ? this.providerFee : 0) + providerFeePer);
            providerFee.textContent = (pFeeStr + ' ' + this._senderCurrency);
            var fixed = NumberHelper.getFixedDigits_New(this._senderCurrency);
            const total = (sending + fee + this.providerFee + providerFeePer).toFixed(fixed);
            const amountTxt = total + ' ' + this._senderCurrency;

            if (HtmlElementHelper.g_elementExists("amount-sending")) {
                document.querySelector("#amount-sending").textContent = sending.toFixed(fixed) + ' ' + this._senderCurrency;
            }
            if (HtmlElementHelper.g_elementExists("amount-total")) {
                document.querySelector("#amount-total").textContent = amountTxt;
            } else if (HtmlElementHelper.g_elementExists("amount-total-txt")) {
                document.querySelector("#amount-total-txt").textContent = amountTxt;
            }
        }
    },

    outletIdChanged: function(event) {
        if(event.target.value === "-1") {
            this.resetSummary();
        } else {
            var feesStr = event.target.options[event.target.selectedIndex].dataset.fees;
            var fees = JSON.parse(feesStr);
            this._updateFees(event.target.value, fees);
        }
    },

    pageLoad: function (o) {
        if(o.value === "-1") {
            this.resetSummary();
        } else {
            var feesStr = o.options[o.selectedIndex].dataset.fees;
            var fees = JSON.parse(feesStr);
            this._updateFees(o.value, fees);
        }
    },

    _updateFees: function(val, fees) {
        if(val === "-1") {
            this.resetSummary();
        } else {
            var aReceivable = jQuery("#amount-receivable");
            var receiving = NumberHelper.toNumber(aReceivable.text());
            var crossEx = 1 / this._exchangeRate;
            //set maxSendingLimit to last element of the array
            this.maxReceivingAmount = fees[fees.length - 1].until_amount;
            for (var i = 0; i < fees.length; i++) {
                var f = fees[i];
                if(f.until_amount <= receiving) {
                    //not interesting -> next slot is the range
                } else {
                    if(f.fee_amount > 0) {
                        this.providerFee = f.fee_amount * crossEx;//fee in sendingCurrency
                        break;
                    } else if(f.fee_percent > 0) {
                        this.providerFee = (f.fee_percent / 100 * receiving) * crossEx;//fee in sendingCurrency
                        break;
                    }
                }
            }

            this.updateSummary();
        }
    }
};